import { defaultNS, useTranslation } from '@/lib/i18n';

import type { Person } from '../types';

export const usePersonActionLabels = (person: Person | null) => {
  const { t: tPage } = useTranslation(defaultNS, {
    keyPrefix: 'pages.apps.integrations',
  });

  const { t: tDialog } = useTranslation(defaultNS, {
    keyPrefix: 'domain.appUser.component.ChangePersonDialog',
  });

  return {
    actionLabel: person ? tPage('changePerson') : tPage('assignPerson'),
    dialogTitle: person
      ? tDialog('changePersonTitle')
      : tDialog('assignPersonTitle'),
    fromLabel: person ? 'From' : tDialog('unidentifiedAccount'),
    toLabel: person ? 'To' : tDialog('assignTo'),
  };
};
